module.exports = __webpack_public_path__ + "static/media/file-text.ee290142.svg";